// Docs: IMPLEMENTATION.md §3.2. Update when changing server-state config
// (staleTime, gcTime, retry/refetch policy).
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // gcTime must be >= the persister's maxAge (24h, see queryPersistence.js)
      // so cached queries stay in memory long enough to be dehydrated to
      // localStorage before iOS kills the standalone app. Persisted payloads
      // are a small allowlist (queryPersistence.js), so the extra retention is
      // cheap; non-persisted blobs are still evicted from storage, just kept in
      // memory for the session.
      gcTime: 24 * 60 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
